import { isArray } from 'lodash';
import { isObservableArray } from 'mobx';

const isAnyArray = data => isArray(data) || isObservableArray(data);

export default isAnyArray;



// WEBPACK FOOTER //
// ./src/core/utils/isAnyArray.js